const aboutCardContent = [
  {
    id: 1,
    cardTitle: "Who we are",
    cardContent: {
      title: "Who we are",
      description1:
        'Our mission, "Harnessing Data. Delivering Insights,"reflects our dedication to helping organizations turn raw data into strategic assets through innovative AI and analytics solutions. We are a team of data scientists, engineers, and AI experts committed to driving growth, improving decision-making, and creating a competitive edge for our clients.',
      description2:
        "What sets Techiserve.ai apart is our ability to blend business acumen with advanced data science. We don't just focus on numbers or algorithms; we focus on how they translate into real-world impact for your business. By understanding your unique challenges and combining that knowledge with powerful data analysis, we provide insights that go beyond the surface, driving smarter decisions and measurable outcomes. Our approach turns complex data into meaningful, actionable strategies that create value where it matters most.",
      imgPath: "/images/about/file.png",
      alt: "Who we are Image",
    },
  },
  {
    id: 2,
    cardTitle: "Why our clients choose us",
    cardContent: {
      title: "Why our clients choose us",
      description1:
        "Since our founding in 2022, Techiserve.ai has earned the trust of businesses by delivering tailored AI and data analytics solutions that address real-world challenges. Our clients value us for our ability to combine deep technical expertise with a personalized approach, ensuring that each solution is customized to their specific needs. From data mining to business application development, we offer comprehensive solutions that help businesses turn data into a strategic asset.",
      description2: "",
      imgPath: "/images/about/file2.png",
      alt: "Why our clients choose us Image",
    },
  },
  {
    id: 3,
    cardTitle: "Our team and delivery capability",
    cardContent: {
      title: "Our team and delivery capability",
      description1:
        "At Techiserve.ai, our team is a blend of diverse expertise, bringing together strengths in chartered accountancy, electrical engineering, chemical engineering, mechatronics engineering, and computer science.",
      description2:
        "This unique combination allows us to approach problems from multiple angles, offering you comprehensive value. Our team members have honed their skills at leading companies like EY, PwC, Exxaro Limited, BMW, and Zulzi, ensuring that we bring both deep technical knowledge and practical business experience to every project. This wide-ranging expertise empowers us to deliver innovative, tailored solutions that meet your business needs.",
      imgPath: "/images/about/file3.png",
      alt: "Our team and delivery capability Image",
    },
  },
];

export default aboutCardContent;
